var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstallationBidOpennedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9169 6.24984L15.8336 3.33317M17.5002 1.6665L15.8336 3.33317L17.5002 1.6665ZM9.4919 9.67484C9.92218 10.0994 10.2642 10.6049 10.4984 11.1622C10.7325 11.7195 10.8541 12.3176 10.8561 12.922C10.8581 13.5265 10.7405 14.1254 10.5102 14.6843C10.2798 15.2431 9.94111 15.7509 9.51368 16.1783C9.08626 16.6057 8.5785 16.9444 8.01965 17.1748C7.4608 17.4052 6.8619 17.5227 6.25742 17.5207C5.65295 17.5187 5.05485 17.3971 4.49755 17.163C3.94026 16.9288 3.43478 16.5868 3.01023 16.1565C2.17534 15.2921 1.71336 14.1343 1.72381 12.9326C1.73425 11.7309 2.21627 10.5813 3.06606 9.73151C3.91585 8.88172 5.06541 8.39969 6.26714 8.38925C7.46888 8.37881 8.62664 8.84078 9.49106 9.67568L9.4919 9.67484ZM9.4919 9.67484L12.9169 6.24984L9.4919 9.67484ZM12.9169 6.24984L15.4169 8.74984L18.3336 5.83317L15.8336 3.33317L12.9169 6.24984Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationBidOpennedIcon);
export default __webpack_public_path__ + "static/media/installationBidOpennedIcon.d5925628cd81ad06fec702344ed0945b.svg";
export { ForwardRef as ReactComponent };